export default __webpack_public_path__ + "static/media/_ghiacco_pile.f1b4f481.png";